import type { AnalyticsAdapter } from "./types";

export class NoopAdapter implements AnalyticsAdapter {
  init(): void {
    // No-op implementation
  }
  
  page(_input: { name?: string; properties?: Record<string, unknown> }): void {
    // No-op implementation
  }
  
  track(_input: { event: string; properties?: Record<string, unknown> }): void {
    // No-op implementation
  }
  
  identify(_input: { userId?: string; traits?: Record<string, unknown> }): void {
    // No-op implementation
  }
  
  reset(): void {
    // No-op implementation
  }
}


